import React from 'react';

import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {ProfessionalDateList} from 'presentation/modules/booking/shared/ui/components/ProfessionalSelection/ProfessionalDateList';
import {ProfessionalDateSection} from 'presentation/modules/booking/shared/ui/components/ProfessionalSelection/ProfessionalDateSection';
import {ExamSelectedDateProfessionalListProps} from './types';

export function ExamSelectedDateProfessionalList({
	list,
	handleSelectHour,
	date,
	query,
}: ExamSelectedDateProfessionalListProps) {
	return (
		<ProfessionalDateList>
			<ProfessionalDateSection
				date={date}
				professionals={list ?? []}
				onSelectHour={handleSelectHour}
				flowType={FlowEnum.EXAM}
				query={query}
			/>
		</ProfessionalDateList>
	);
}
